import React, { useMemo, useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';
import SagaCommonMessages from 'sg-common-messages';
import moment from 'moment';
import { Button } from '@jutro/components';

function SgSpmClaimsTable(props) {
    const {
        claims,
        editingClaimIndex,
        onRemoveClaim,
        onEditClaim,
        isClaimFormVisible
    } = props;

    const translator = useContext(TranslatorContext);
    const tableBody = useMemo(() => {
        return claims.map((claim, index) => {
            if (index !== editingClaimIndex) {
                return (
                    <div className="sgClaimConviction" key={claim.tempID || claim.publicID}>
                        <div className="sgClaimConvictionDetails">
                            <span className="sgClaimConvictionValue">
                                {moment(new Date(claim.claimDate.year, claim.claimDate.month, claim.claimDate.day)).format('MMM YYYY')}
                            </span>
                            <span className="sgClaimConvictionValue">
                                {translator({ id: `typekey.MotorClaimType_Ext.${claim.type}`, defaultMessage: '' }) }
                            </span>
                        </div>
                        <div className="sgClaimConvictionsButtonContainer">
                            <Button
                                id={`editClaim${index}`}
                                disabled={claim.isCueClaims || isClaimFormVisible}
                                className="sgButton sgSecondaryWhiteButton"
                                onClick={() => onEditClaim(index)}
                            >
                                {translator(SagaCommonMessages.edit)}
                            </Button>
                            <Button
                                id={`removeClaim${index}`}
                                disabled={claim.isCueClaims || isClaimFormVisible}
                                onClick={() => onRemoveClaim(index)}
                                className="sgButton sgSecondaryWhiteButton"
                            >
                                {translator(SagaCommonMessages.remove)}
                            </Button>
                        </div>
                    </div>
                );
            }
            return <React.Fragment key={claim.tempID || claim.publicID} />;
        });
    }, [claims, editingClaimIndex, claims.length, onEditClaim, onRemoveClaim]);

    return (
        <div className="sgClaimsAndConvictionsSummaryContainer">
            <div className="sgClaimsConvictionsHeader">
                <span>{translator(SagaCommonMessages.date)}</span>
                <span>{translator(SagaCommonMessages.type)}</span>
            </div>
            {tableBody}
        </div>
    );
}

export default SgSpmClaimsTable;
